module.exports = __webpack_public_path__ + "img/uk-cerebrovascular-disease-female.814878f8.png";